import { Injectable } from '@angular/core';
import { RequestsProvider } from '../requests/requests';
import { environment } from '../../../../environments/environment';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { LoggerFactory } from '../logger/logger-factory.service';

@Injectable({ providedIn: 'root' })
export class OtWithStiProvider {
  private logger: LoggerWrapper;

  private readonly apiUrlDactechBack: string = '';
  private readonly OT_STI_PATH: string = '/ots/';

  constructor(
    private requestsProvider: RequestsProvider,
    private loggerFactory: LoggerFactory
  ) {
    this.apiUrlDactechBack = environment.apis.API_DACTECH_BACK_V1;
    this.logger = this.loggerFactory.getInstance(this);
  }

  async activateSti(idOt: string) {
    try {
      await this.requestsProvider.put(this.apiUrlDactechBack + this.OT_STI_PATH + idOt + '/activateSti', null);
    } catch (e) {
      this.logger.warn('unable to activate sti for demande related to ot ' + idOt);
    }
  }
}
